import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Field, Form, Formik, useFormik } from "formik";
import config from "../../config/config";
import { Tabs, Tab, Offcanvas, Modal } from "react-bootstrap";
import Select from "react-select";
import Loader from "../Loader/Loader";
import { event } from "jquery";
import { toastError, toastSuccess, toastWarn } from "../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
} from "../../common/Constant";
import CommonMatrialReactTableServerSideRender from "../Datatable/CommonMatrialReactTableServerSideRender";
import { checkUserPermission } from "../../common/UserPermission";
import { Box, MenuItem } from "@mui/material";
import AddressModal from "./AddressModal";
import moment from "moment";
// import Loader from "../../components/Loader/Loader";
let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";

const Deliveriescard = ({
  callback,
  shippingadd,
  setShippingAddressId,
  customerid,
  selectedshippingadd,
  salesDeliveryDetails,
  salesdeliverydata,
  saleDeliveryOtherSection,
  show,
  handlecloses,
}) => {
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const saleId = paramObject?.id ?? paramObject?.saleId ?? 0;

  console.log(paramObject, saleId, "paramObjectcheck");

  const columns = [
    { header: "Address1", accessorKey: "Address1" },
    { header: "Address2", accessorKey: "Address2" },
    { header: "City", accessorKey: "City" },
    { header: "StateProvince", accessorKey: "StateProvince" },
    { header: "Country", accessorKey: "Country" },
    { header: "Zip", accessorKey: "Zip" },
  ];

  const [AddressEdit, setAddressEdit] = useState({
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    ID: 0,
    ShippingDefault: 0,
  });
  const [open, setOpen] = useState(false);

  const [fulladdress, setfulladdress] = useState([]);

  const [localValues, setLocalValues] = useState({});
  const [selectedshippingadds, setselectedshippingadd] =
    useState(selectedshippingadd);
  const [activeTab, setActiveTab] = useState("ShippingAddress");

  const [formValues, setFormValues] = useState({
    ID: "",
    SaleId: 0,
    DeliveryEmployee: "",
    Trackingno: "",
    ExpectedProcessing: "",
    ExpectedDelivery: "",
    DeliveryComment: "",
    Status: "",
    CategoryId: "",
    Duration: "",
    LocationId: "",
    ExpectedPickUp: "",
    FirstName: "",
    LastName: "",
    PhoneNumber: "",
    EMail: "",
    contactPreference: 0,
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    DeliveryFees: salesDeliveryDetails?.DeliveryFees
      ? salesDeliveryDetails?.DeliveryFees
      : "",
    ShippingZone: "",
    Taxgroup: "",
    homenumber: "",
  });

  console.log(formValues, "410501");

  const [loading, setLoading] = useState(false);
  const [statusDropdown, setStatusDropdown] = useState([]);
  const [categoryDropdown, setCategoryDown] = useState([]);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [durationDropdown, setDurationDropdown] = useState([]);
  const [dateTime, setDateTime] = useState("");
  const [deliverydateTime, setDeliveryDateTime] = useState("");
  const [expectedpickup, setExpectedPickUp] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [deliveryemployeeDropdown, setDeliveryemployeeDropdown] = useState([]);

  const [status, setStatus] = useState(0);
  const [deliveryEmployee, setDeliveryEmployee] = useState(0);
  const [categoryId, setCategoryId] = useState(0);
  const [locationId, setLocationId] = useState(0);
  const [durationValue, setDuration] = useState(0);
  const [ispickup, setIspickup] = useState(0);
  const [taxDropdown, setTaxDropdown] = useState([]);
  const [taxDropdownValue, setTaxDropdownValue] = useState("");

    console.log(ispickup, "ispickup check");
  const [saleTypeMethod, setSaleTypeMethod] = useState([0]); // Store options
  const [deliveryMethodId, setDeliveryMethodId] = useState(0); // 1

  useEffect(() => {
    setselectedshippingadd(selectedshippingadd);
  }, [selectedshippingadd]);

  useEffect(() => {
    if (saleDeliveryOtherSection) {
      setDeliveryMethodId(saleDeliveryOtherSection?.deliveryMethodId);
    }
  }, [saleDeliveryOtherSection]);

  useEffect(() => {
    setfulladdress(shippingadd);
  }, [shippingadd]);

  console.log(deliveryEmployee, "dateTime check");

  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/taxclassdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTaxDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });
    setLocationId(localStorage.getItem("Location"));
  }, []);

  let statusOptions = [];
  const statusDropDownData = statusDropdown.map((u, i) => {
    statusOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  let employeeOptions = [];
  const employeeDropDownData = deliveryemployeeDropdown.map((u, i) => {
    employeeOptions[i] = {
      label: u.Name,
      value: u.Id,
    };
  });

  let categoryOptions = [];
  const categoryDropDownData = categoryDropdown.map((u, i) => {
    categoryOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  let locationOptions = [];
  const locationDropDownData = locationDropdown.map((u, i) => {
    locationOptions[i] = {
      label: u.Name,
      value: u.Id,
    };
  });

  let durationOptions = [];
  const durationDropDownData = durationDropdown.map((u, i) => {
    durationOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  let usersDropdownOption = [];
  // const userDropdown = shippingadd.map((u, i) => {
  const userDropdown = fulladdress.map((u, i) => {
    usersDropdownOption[i] = { label: u.Address1 + u.Address2, value: u.ID };
  });

  console.log(selectedshippingadds, "new410");
  // console.log(selectedshippingadd,usersDropdownOption,"555555",shippingadds)

  const AddAddress = (event) => {
    console.log(event, "454511");
    setselectedshippingadd(event ? event?.value : 0);
  };

  const handleclicks = () => {
    setOpen(true);
    setAddressEdit({
      Address1: "",
      Address2: "",
      City: "",
      StateProvince: "",
      Zip: "",
      Country: "",
      ID: 0,
      ShippingDefault: 0,
    });
  };

  useEffect(() => {
    let newocj = shippingadd?.filter((item) => item.ID == selectedshippingadds);
    console.log("0000", newocj);

    setFormValues((prevValues) => ({
      ...prevValues,
      ...newocj[0],
    }));
  }, [selectedshippingadds, selectedshippingadd]);

  useEffect(() => {
    // if (paramObject?.id === undefined) {
    if (saleId == 0) {
      if (salesDeliveryDetails !== undefined) {
        const draftFromLocalStorage = JSON.parse(
          localStorage.getItem("DeliveryDraft")
        );

        const updatedLocalValues = {
          ...localValues,
          deliveryFees:
            draftFromLocalStorage?.deliveryFees !== undefined
              ? draftFromLocalStorage?.deliveryFees
              : 0,
          salesDeliveryDetails:
            draftFromLocalStorage?.salesDeliveryDetails !== undefined
              ? draftFromLocalStorage.salesDeliveryDetails
              : salesDeliveryDetails,
        };
        setLocalValues(updatedLocalValues);
        localStorage.setItem(
          "DeliveryDraft",
          JSON.stringify(updatedLocalValues)
        );
      }
    }
  }, [paramObject, salesDeliveryDetails]);

  // const handleInputClick = () => {
  //   const now = new Date();
  //   const formattedDateTime = now.toISOString().slice(0, 16);
  //   if (paramObject.id === undefined) {
  //     const x = { ...localValues, dateTime: formattedDateTime };
  //     setLocalValues(x);
  //     localStorage.setItem("DeliveryDraft", JSON.stringify(x));
  //   }
  //   setDateTime(formattedDateTime);
  // };

  const [mappedItem, setMappedItem] = useState([]);
  const handleTaxDropdown = (event) => {
    // if (paramObject?.id === undefined) {
    if (saleId == 0) {
      const x = {
        ...localValues,
        taxDropdownValue: Number(event.target.value),
      };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
    setTaxDropdownValue(event.target.value);
    setLoading(true);
    axios
      .get(
        `${config.generalBaseUrl}/generals/taxclassfindbyid?taxclassid=${event.target.value}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const response = res.data.ResponseData;
          const mappedReceivingItems = response.map((item) => {
            const mappedItem = {
              TaxName: item.Name,
              TaxPercent: parseInt(item.Percent),
              type: "deliveryTax",
              TaxItemID: "",
              TaxVariationID: "",
            };

            return mappedItem;
          });
          setMappedItem(mappedReceivingItems);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          setLoading(false);
        } else {
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };



  //status dropdown
  const handleDropdownData = (DeliveryData) => {
    // console.log(DeliveryData,"DeliveryData")
    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("employee", res);
        setDeliveryemployeeDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/deliverystatuslist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setStatusDropdown(res.data.ResponseData);

        return res;
      });

    //category dropdown
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/categoriesfindall`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoryDown(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res);
        setLocationDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/durationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res);
        setDurationDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  };

  useEffect(() => {
    handleDropdownData();

    const finalobj = {
      ID: salesDeliveryDetails?.Id > 0 ? salesDeliveryDetails?.Id : formValues.ID,
      SaleId: salesDeliveryDetails?.Saleid,
      DeliveryEmployee:
        salesDeliveryDetails?.EmployeId > 0
          ? salesDeliveryDetails?.EmployeId
          : 0 || localValues?.deliveryEmployee,
      Trackingno:
        salesDeliveryDetails?.TranckingNumber || localValues?.trackingNumber,
      ExpectedProcessing:
        salesDeliveryDetails?.EstimatedShippingDate || localValues?.dateTime,
      ExpectedDelivery:
        salesDeliveryDetails?.EstimatedDeliveryDate ||
        localValues?.deliveryDateTime,
      DeliveryComment:
        salesDeliveryDetails?.Comments || localValues?.deliveryComment,
      Status: salesDeliveryDetails?.Status || localValues?.status,
      CategoryId: salesDeliveryDetails?.CategoryId || localValues?.category,
      Duration: salesDeliveryDetails?.Duration || localValues?.duration,
      LocationId: salesDeliveryDetails?.LocationId || localValues?.location,
      ExpectedPickUp: salesDeliveryDetails?.EstimatedDeliveryDate,
      FirstName:
        localValues?.salesDeliveryDetails?.FirstName ||
        salesDeliveryDetails?.FirstName,
      LastName:
        salesDeliveryDetails?.LastName ||
        localValues?.salesDeliveryDetails?.LastName,
      PhoneNumber:
        salesDeliveryDetails?.PhoneNumber ||
        localValues?.salesDeliveryDetails?.PhoneNumber,
      EMail:
        salesDeliveryDetails?.Email || localValues?.salesDeliveryDetails?.Email,
      contactPreference: salesDeliveryDetails?.ContactPrefrence,
      Address1:
        formValues?.Address1 || localValues?.salesDeliveryDetails?.Address1,
      Address2:
        formValues?.Address2 || localValues?.salesDeliveryDetails?.Address2,
      homenumber:
        salesDeliveryDetails?.homenumber ||
        localValues?.salesDeliveryDetails?.homenumber,
      City: formValues?.City || localValues?.salesDeliveryDetails?.City,
      StateProvince: formValues?.StateProvince,
      Zip: formValues?.Zip || localValues?.salesDeliveryDetails?.Zip,
      Country: formValues?.Country,
      DeliveryFees:
        salesDeliveryDetails?.DeliveryFees === undefined
          ? salesDeliveryDetails?.DeliveryFees
          : salesDeliveryDetails?.DeliveryFees || localValues.deliveryFees,
      ShippingZone:
        salesDeliveryDetails?.Shippingzoneid === undefined
          ? 0
          : salesDeliveryDetails?.Shippingzoneid,
      Taxgroup:
        salesDeliveryDetails?.Taxclassid === undefined
          ? 0
          : salesDeliveryDetails?.Taxclassid,
    };

    console.log(salesDeliveryDetails, "finalobj");
    console.log(finalobj, "finalobj");

    setFormValues(finalobj);

    // if (paramObject.id !== undefined) {
    if (saleId != 0) {
      setStatus(salesDeliveryDetails?.Status);
      setDeliveryEmployee(salesDeliveryDetails?.EmployeId);
      setCategoryId(salesDeliveryDetails?.CategoryId);
      setLocationId(salesDeliveryDetails?.LocationId);
      setDuration(salesDeliveryDetails?.Duration);
      setSelectedOption(salesDeliveryDetails?.ContactPrefrence);
      setIspickup(salesDeliveryDetails?.Ispickup);
    }

    if (salesDeliveryDetails?.EstimatedShippingDate != undefined) {
      const estimatedShippingDate = new Date(
        salesDeliveryDetails?.EstimatedShippingDate
      );
      if (moment(estimatedShippingDate).isValid()) {
        const formattedDate = moment(estimatedShippingDate).format(
          "YYYY-MM-DDTHH:mm"
        );
        setDateTime(formattedDate);
      }
      console.log(estimatedShippingDate, "estimatedShippingDate");
      
      // setDateTime(estimatedShippingDate.toISOString().slice(0, 16)); 
    }

    if (salesDeliveryDetails?.EstimatedDeliveryDate != undefined) {
      const estimatedDeliveryDate = new Date(
        salesDeliveryDetails?.EstimatedDeliveryDate
      );
      if (moment(estimatedDeliveryDate).isValid()) {
        const formattedDate = moment(estimatedDeliveryDate).format(
          "YYYY-MM-DDTHH:mm"
        );
        if (salesDeliveryDetails?.Ispickup == 1) {
          setExpectedPickUp(formattedDate);
        } else {
          setDeliveryDateTime(formattedDate);
        }
      }

      // if (salesDeliveryDetails?.Ispickup == 1) {
      //   setExpectedPickUp(estimatedDeliveryDate.toISOString().slice(0, 16));
      // } else {
      //   setDeliveryDateTime(estimatedDeliveryDate.toISOString().slice(0, 16));
      // }
    }
  }, [salesDeliveryDetails, localValues]);

  const handleInputdeliveryClick = () => {
    console.log("delivery click");

    // If already has value, do nothing
    if (deliverydateTime) return;

    const now = moment().format("YYYY-MM-DDTHH:mm"); // Local time in correct input format

    // if (paramObject.id === undefined) {
    if (saleId == 0) {
      const x = { ...localValues, deliveryDateTime: now };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }

    setDeliveryDateTime(now);
  };

  const handleDatedeliveryTimeChange = (event) => {
    console.log(event.target.value, "deliverydateTime");

    setDeliveryDateTime(event.target.value);
    // if (paramObject.id === undefined) {
    if (saleId == 0) {
      const x = { ...localValues, deliveryDateTime: event.target.value };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

    const handleExpectedClick = () => {
    // const now = new Date();
    // const formattedDateTime = now.toISOString().slice(0, 16);
    // setExpectedPickUp(formattedDateTime);

        // If already has value, do nothing
    if (expectedpickup) return;

    const now = moment().format("YYYY-MM-DDTHH:mm"); // Local time in correct input format

    if (saleId == 0) {
      const x = { ...localValues, expectedpickup: now };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }

    setExpectedPickUp(now);
    
  };

  const handleExpectedChange = (event) => {
    setExpectedPickUp(event.target.value);
    // if (paramObject.id === undefined) {
    if (saleId == 0) {
      const x = { ...localValues, expectedPickUp: event.target.value };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

  const handleInputClick = () => {
    console.log(paramObject, "delivery click");

    // If already has value, do nothing
    if (dateTime) return;

    const now = moment().format("YYYY-MM-DDTHH:mm"); // Local time in correct input format

    if (saleId == 0) {
      // if (paramObject.id === undefined) {
      const x = { ...localValues, dateTime: now };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }

    setDateTime(now);
  };

  const handleDateTimeChange = (event) => {
    console.log(event.target.value, "dateTime");
    setDateTime(event.target.value);

    if (saleId == 0) {
      // if (paramObject.id === undefined) {
      const x = { ...localValues, dateTime: event.target.value };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

  const handleEmployeeChange = (event) => {
    console.log(event, "dateTime");
    setDeliveryEmployee(event?.value);
    setFormValues({ ...formValues, DeliveryEmployee: event?.value });

    if (saleId == 0) {
      const x = {
        ...localValues,
        deliveryEmployee: event?.value,
      };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

  const handleChangecheck = (event) => {
    // console.log(event.target.name);
    const { value } = event.target;

    // if (paramObject.id === undefined) {
    if (saleId == 0) {
      const x = {
        ...localValues,
        salesDeliveryDetails: {
          ...localValues.salesDeliveryDetails,
          selectedOption: event?.target?.value,
        },
      };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }

    if (value == 1) {
      setSelectedOption(1);
    } else if (value == 2) {
      setSelectedOption(2);
    } else if (value == 3) {
      setSelectedOption(3);
    }
  };

  const handleSubmit = (values) => {
    console.log(values, "154258");
    if (values.homenumber < 0) {
      toastWarn("fill home Number First");
      return;
    }

    // localStorage.removeItem("DeliveryDraft")
    let DelivriesData = {
      Id: values.ID || 0,
      Saleid: values.SaleId != undefined ? values.SaleId : 0,
      EmployeId: saleId == 0 ? localValues?.deliveryEmployee : deliveryEmployee, // values.DeliveryEmployee,
      Status: saleId == 0 ? localValues?.status : status, //values.Status,
      CategoryId: categoryId != undefined ? categoryId : 0, // values.CategoryId,
      Duration: saleId == 0 ? localValues?.duration : durationValue, // values.Duration,
      LocationId: locationId === undefined ? 0 : locationId, // values.LocationId,
      FirstName: values.FirstName,
      LastName: values.LastName,
      Email: values.EMail,
      PhoneNumber: values.PhoneNumber,
      ContactPrefrence: selectedOption != undefined ? selectedOption : 0,
      Address1: values.Address1,
      Address2: values.Address2,
      homenumber: values.homenumber,
      City: values.City,
      StateProvince: values.StateProvince,
      Zip: values.Zip,
      Country: values.Country,
      TranckingNumber: saleId == 0 ? values.Trackingno : formValues.Trackingno, // values.Trackingno,
      Comments: values.DeliveryComment,
      EstimatedShippingDate: dateTime,
      EstimatedDeliveryDate: ispickup == 1 ? expectedpickup : deliverydateTime,
      DeliveryFees: values.DeliveryFees || salesDeliveryDetails?.DeliveryFees,
      Shippingzoneid:
        values.ShippingZone != undefined ? values.ShippingZone : 0,
      Taxclassid: values.Taxgroup != undefined ? values.Taxgroup : 0,
      Loginuserid: Id,
      Ispickup: ispickup != undefined ? ispickup : 1,
      deliveryMethodId: deliveryMethodId ? deliveryMethodId : 0,
      Isdelivery: 1,
      CustomerId: customerid,
    };

    console.log(DelivriesData, "DelivriesData");
    // return

    callback(DelivriesData, mappedItem);

    let reqobj = {
      ID: formValues.ID || 0,
      CustomerId: customerid,
      Add1: values.Address1,
      Add2: values.Address2,
      City: values.City,
      StateProvince: values.StateProvince,
      Zip: values.Zip,
      Country: values.Country,
      loginuserID: Id,
    };

    setLoading(true);
    axios
      .post(
        `${config.customersBaseUrl}/customers/CustomerShipingAddByID`,
        reqobj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        toastSuccess("Shipping address added successfully");
        // setfetchdata((t) => !t);

        // setAddresss({
        //   Address1: "",
        //   Address2: "",
        //   City: "",
        //   StateProvince: "",
        //   Zip: "",
        //   Country: "",
        //   ID: "",
        // });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    // setMappedItem([]);
  };

  const handleCancelClick = () => {
    localStorage.removeItem("dataAfterDelivery");
    // localStorage.removeItem("DeliveryDraft");

    const draftFromLocalStorage = JSON.parse(
      localStorage.getItem("DeliveryDraft")
    );

    const updatedLocalValues = {
      deliveryFees: 0,
      salesDeliveryDetails: {},
    };
    setLocalValues(updatedLocalValues);
    localStorage.setItem("DeliveryDraft", JSON.stringify(updatedLocalValues));

    setStatus(0);
    setDeliveryEmployee(0);
    setCategoryId(0);
    setLocationId(0);
    setDuration(0);
    setDeliveryDateTime(null);
    setDateTime(null);
    setExpectedPickUp(null);
    setIspickup(0);

    setFormValues({
      ID: 0,
      SaleId: 0,
      DeliveryEmployee: "",
      Trackingno: "",
      ExpectedProcessing: "",
      ExpectedDelivery: "",
      DeliveryComment: "",
      Status: "",
      CategoryId: "",
      Duration: "",
      LocationId: "",
      ExpectedPickUp: "",
      FirstName: "",
      LastName: "",
      PhoneNumber: "",
      EMail: "",
      contactPreference: 0,
      Address1: "",
      Address1: "",
      City: "",
      State: "",
      Zip: "",
      Country: "",
      DeliveryFees: salesdeliverydata?.DeliveryFees
        ? salesdeliverydata?.DeliveryFees
        : "",
      ShippingZone: "",
      Taxgroup: "",
    });

    let CancelDelivery = { CancelDelivery: true };

    callback("CancelDelivery", mappedItem);
  };

 

  useEffect(() => {
    // if (paramObject.id === undefined) {
    if (saleId == 0) {
      const savedData = localStorage.getItem("DeliveryDraft");
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        setLocalValues(parsedData);
        // setDeliveryEmployee(parsedData.deliveryEmployee)
        setFormValues({
          ...formValues,
          DeliveryEmployee: parsedData?.deliveryEmployee,
          LocationId: parsedData?.location,
          Status: parsedData?.status,
          Duration: parsedData?.duration,
          Trackingno: parsedData?.trackingNumber,
          DeliveryComment: parsedData?.deliveryComment,
          DeliveryFees: parsedData?.deliveryFees,
          CategoryId: parsedData?.category,
          deliveryDateTime: parsedData?.deliveryDateTime,
          dateTime: parsedData?.dateTime,
          expectedPickUp: parsedData?.expectedPickUp,
        });
        setDeliveryDateTime(parsedData?.deliveryDateTime);
        setExpectedPickUp(parsedData?.expectedPickUp);
        setDateTime(parsedData?.dateTime);
        setCategoryId(parsedData?.category);
        setTaxDropdownValue(parsedData?.taxDropdownValue);
        setSelectedOption(parsedData?.salesDeliveryDetails?.selectedOption);
      }
    }
  }, []);

  useEffect(() => {
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/deliverymethodlist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const deliveryData = response.data.ResponseData?.map((el) => {
          return { label: el.Name, value: el.ID };
        });
        setSaleTypeMethod(deliveryData || []);

        // Set default to the first option, if available
        setDeliveryMethodId(salesdeliverydata?.deliveryMethodId || 0); // 1
        console.log(
          response.data.ResponseData,
          salesdeliverydata,
          "=====deliverymethodlist"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  
   const handleChangeTable = (pValue) => {
    console.log(pValue, "pValue");
    if (pValue == "methodInstorePickup") {
      setIspickup(1);

      // if (paramObject.id === undefined) {
      if (saleId == 0) {
        const x = {
          ...localValues,
          Ispickup: 1,
        };
        setLocalValues(x);
        localStorage.setItem("DeliveryDraft", JSON.stringify(x));
      }
    } else {
      setIspickup(0);
      // if (paramObject.id === undefined) {
      if (saleId == 0) {
        const x = {
          ...localValues,
          Ispickup: 0,
        };
        setLocalValues(x);
        localStorage.setItem("DeliveryDraft", JSON.stringify(x));
      }
    }
  };

  const handleDeleteAddress = (addressdata) => {
    console.log(addressdata, "check delete addressdata");

    let payload = {
      id: addressdata.ID,
      loginuserid: Number(Id),
      customerid: addressdata.CustomerID,
    };

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/customershippingaddressdelete`,
        payload,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData, "resResponseData");

        if (
          res.data.ResponseCode === "SUCCESS" &&
          res.data.ResponseData[0].ID > 0
        ) {
          toastSuccess("Shipping Address Deleted Successfully");
          handlecloses();
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const getShippingAddressByCustomerId = () => {
    setLoading(true);
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/ShiipingAdresssbyID?CustomerID=${customerid}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setfulladdress(res.data.ResponseData);
        const defaultAddress = res.data.ResponseData.find(
          (addr) => addr.ShippingDefault == 1
        );
        setselectedshippingadd(defaultAddress?.ID || selectedshippingadd);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false);
  };

  useEffect(() => {
    getShippingAddressByCustomerId();
  }, [open]);

  const yesID =
    shippingadd.find((item) => item.ShippingDefault > 0)?.ID ??
    shippingadd.find((item) => item.LastSaleAddressID == item.ID)?.ID ??
    shippingadd.find((item) => item.IsDefault == 1)?.ID ??
    null;

  return (
    <>
      <Loader loading={loading} />
      <Modal
        show={show}
        onHide={handlecloses}
        backdrop="static"
        keyboard={false}
        id="DeliveriesModal"
        centered
        fullscreen
      >
        <Modal.Body>
          <button
            type="button"
            className="btn-close float-end"
            aria-label="Close"
            onClick={handlecloses}
          >
            {" "}
            X{" "}
          </button>

          <Formik
            {...salesDeliveryDetails}
            initialValues={formValues}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Form>
                <Field
                  type="hidden"
                  className="form-control"
                  id="ID"
                  name="ID"
                  value={values.ID}
                />
                <Field
                  type="hidden"
                  className="form-control"
                  id="SaleId"
                  name="SaleId"
                  value={values.SaleId}
                />

                <Tabs
                  defaultActiveKey="LocalDelivery"
                  id="form-tabs"
                  className="mb-4"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                >
                  <Tab
                    eventKey="ShippingAddress"
                    title="Select Shipping Address"
                  >
                    {/* <p> {formValues?.ID}</p> */}
                    <div
                      className="col-xxl-4 col-xl-4 col-lg-4 col-md-8 col-sm-8 col-12"
                      style={
                        {
                          // display: "flex",
                          // justifyContent: "space-between",
                          // alignItems: "center",
                          // marginBottom:"20px"
                        }
                      }
                    >
                      <div>
                        <Select
                          options={usersDropdownOption}
                          className="custom-search-select mt-1"
                          value={
                            usersDropdownOption.find(
                              (el) => el.value == selectedshippingadds
                            ) || null
                          }
                          isClearable={true}
                          onChange={(e) =>
                            setShippingAddressId(e ? e?.value : 0)
                          }
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        />
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="method" title="Delivery Method">
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div
                            className="card-header"
                            style={{ "text-align": "left" }}
                          >
                            <Tabs
                              defaultActiveKey="methoddelivery"
                              id="form-tabs1"
                              className="mb-4"
                              defaultIndex={1}
                              onSelect={(index) => handleChangeTable(index)}
                            >
                              <Tab eventKey="methoddelivery" title="Delivery">
                                <div
                                  className="row"
                                  style={{ "text-align": "left" }}
                                >
                                  <div className="form-group row">
                                    <label className="col-form-label col-md-3">
                                      Delivery Employee
                                    </label>
                                    <div className="col-md-9">
                                      <Select
                                        onChange={(event) => {
                                          handleEmployeeChange(event);
                                          // if (paramObject.id === undefined) {
                                        }}
                                        value={employeeOptions.find(
                                          (option) =>
                                            option?.value ==
                                            formValues.DeliveryEmployee
                                        )}
                                        options={employeeOptions}
                                        id="DeliveryEmployee"
                                        name="DeliveryEmployee"
                                        className="custom-search-select"
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-form-label col-md-3">
                                      Tracking Number
                                    </label>
                                    <div className="col-md-9">
                                      <Field
                                        type="text"
                                        name="Trackingno"
                                        id="Trackingno"
                                        className="form-control form-control-sm"
                                        onBlur={handleBlur}
                                        onChange={(event) => {
                                          handleChange(event);
                                          const trackingNumberValue =
                                            event.target.value;
                                            setFormValues((prevFormValues) => ({
                                          ...prevFormValues,
                                          Trackingno: trackingNumberValue,
                                        }));
                                          // Save the tracking number value to localStorage
                                          // if (paramObject.id === undefined) {
                                          if (saleId == 0) {
                                            const x = {
                                              ...localValues,
                                              trackingNumber:
                                                trackingNumberValue,
                                            };
                                            setLocalValues(x);
                                            localStorage.setItem(
                                              "DeliveryDraft",
                                              JSON.stringify(x)
                                            );
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-form-label col-md-3 form-label">
                                      Expected Processing
                                    </label>
                                    <div className="col-md-9">
                                      <Field
                                        type="datetime-local"
                                        className="form-control"
                                        onClick={handleInputClick}
                                        onChange={handleDateTimeChange}
                                        value={dateTime}
                                        id="ExpectedProcessing"
                                        name="ExpectedProcessing"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-form-label col-md-3 form-label">
                                      Expected Delivery
                                    </label>
                                    <div className="col-md-9">
                                      <Field
                                        type="datetime-local"
                                        className="form-control"
                                        onClick={handleInputdeliveryClick}
                                        onChange={handleDatedeliveryTimeChange}
                                        value={deliverydateTime}
                                        id="ExpectedDelivery"
                                        name="ExpectedDelivery"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Tab>
                              <Tab
                                eventKey="methodInstorePickup"
                                title="Instore Pickup"
                              >
                                <div className="row">
                                  <div className="form-group row">
                                    <label className="col-form-label col-md-3 form-label">
                                      Expected Pick-Up
                                    </label>
                                    <div className="col-md-9">
                                      <Field
                                        type="datetime-local"
                                        className="form-control"
                                        onClick={handleExpectedClick}
                                        onChange={handleExpectedChange}
                                        value={expectedpickup}
                                        id="ExpectedPickUp"
                                        name="ExpectedPickUp"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Tab>
                            </Tabs>

                            <div className="row">
                              <div className="col-md-12">
                                <div className="form-group row">
                                  <label className="col-form-label col-md-3">
                                    Delivery Comment
                                  </label>
                                  <div className="col-md-9">
                                    <Field
                                      as="textarea"
                                      name="DeliveryComment"
                                      id="DeliveryComment"
                                      className={`form-control`}
                                      rows={5}
                                      cols={5}
                                      onBlur={handleBlur}
                                      onChange={(event) => {
                                        handleChange(event);
                                        const deliveryCommentValue = event.target.value;
                                        setFormValues((prevFormValues) => ({
                                          ...prevFormValues,
                                          DeliveryComment: deliveryCommentValue,
                                        }));
                                        // if (paramObject.id === undefined) {
                                        if (saleId == 0) {
                                          const x = {
                                            ...localValues,
                                            deliveryComment:
                                              event?.target?.value,
                                          };
                                          setLocalValues(x);
                                          localStorage.setItem(
                                            "DeliveryDraft",
                                            JSON.stringify(x)
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-form-label col-md-3">
                                    Status
                                  </label>
                                  <div className="col-md-9">
                                    <Select
                                      // onChange={handleChange}
                                      onChange={(event) => {
                                        console.log(event.value, "875410501");
                                        setStatus(event.value);
                                        setFormValues((prevFormValues) => ({
                                          ...prevFormValues,
                                          Status: event?.value,
                                        }));
                                        // const x = { ...localValues, status: event?.value };
                                        // setLocalValues(x);
                                        // localStorage.setItem("DeliveryDraft", JSON.stringify(x))
                                        // if (paramObject.id === undefined) {
                                        if (saleId == 0) {
                                          const x = {
                                            ...localValues,
                                            status: event?.value,
                                          };
                                          setLocalValues(x);
                                          localStorage.setItem(
                                            "DeliveryDraft",
                                            JSON.stringify(x)
                                          );
                                        }
                                      }}
                                      value={statusOptions.find(
                                        (option) =>
                                          option?.value == formValues.Status
                                      )}
                                      options={statusOptions}
                                      id="Status"
                                      name="Status"
                                      className="custom-search-select"
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-form-label col-md-3">
                                    Category
                                  </label>
                                  <div className="col-md-9">
                                    <Select
                                      onChange={(event) => {
                                        setCategoryId(event.value);
                                        // if (paramObject.id === undefined) {
                                        if (saleId == 0) {
                                          const x = {
                                            ...localValues,
                                            category: event?.value,
                                          };
                                          setLocalValues(x);
                                          localStorage.setItem(
                                            "DeliveryDraft",
                                            JSON.stringify(x)
                                          );
                                        }
                                      }}
                                      value={categoryOptions.find(
                                        (option) =>
                                          option?.value ==
                                          formValues?.CategoryId
                                      )}
                                      options={categoryOptions}
                                      id="CategoryId"
                                      name="CategoryId"
                                      className="custom-search-select"
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label className="col-form-label col-md-3">
                                    Duration
                                  </label>
                                  <div className="col-md-9">
                                    <Select
                                      onChange={(event) => {
                                        setDuration(event.value);
                                        setFormValues((prevFormValues) => ({
                                          ...prevFormValues,
                                          Duration: event?.value,
                                        }));
                                        // if (paramObject.id === undefined) {
                                        if (saleId == 0) {
                                          const x = {
                                            ...localValues,
                                            duration: event?.value,
                                          };
                                          setLocalValues(x);
                                          localStorage.setItem(
                                            "DeliveryDraft",
                                            JSON.stringify(x)
                                          );
                                        }
                                      }}
                                      value={durationOptions.find(
                                        (option) =>
                                          option?.value == formValues.Duration
                                      )}
                                      options={durationOptions}
                                      id="Duration"
                                      name="Duration"
                                      className="custom-search-select"
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-form-label col-md-3">
                                    Location
                                  </label>
                                  <div className="col-md-9">
                                    <Select
                                      onChange={(event) => {
                                        setLocationId(event.value);
                                        // if (paramObject.id === undefined) {
                                        if (saleId == 0) {
                                          const x = {
                                            ...localValues,
                                            location: event?.value,
                                          };
                                          setLocalValues(x);
                                          localStorage.setItem(
                                            "DeliveryDraft",
                                            JSON.stringify(x)
                                          );
                                        }
                                      }}
                                      value={locationOptions.find(
                                        (option) =>
                                          option?.value == formValues.LocationId
                                      )}
                                      options={locationOptions}
                                      id="LocationId"
                                      name="LocationId"
                                      className="custom-search-select"
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="address" title="Delivery Address">
                    <div
                      className="row"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="col-md-10"> </div>

                      <div className=" col-md-2  ms-auto">
                        <button
                          type="button"
                          onClick={handleclicks}
                          className="btn btn-primary "
                        >
                          Add Shipping Address
                        </button>
                      </div>
                    </div>

                    <div class=" mt-3 mb-3">
                      <table
                        style={{
                          borderCollapse: "collapse",
                          width: "100%",
                        }}
                      >
                        <thead>
                          <tr>
                            <th className="thStyle"> sr.No </th>
                            <th className="thStyle">Address1</th>
                            <th className="thStyle">Address2</th>
                            <th className="thStyle">City</th>
                            <th className="thStyle">State/Province</th>
                            <th className="thStyle">Country</th>
                            <th className="thStyle">Zip</th>
                            <th className="thStyle"> Created By </th>
                            <th className="thStyle">Is Shipping Default</th>
                            <th className="thStyle">Address Type</th>
                            <th className="thStyle">Edit</th>
                            <th className="thStyle">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fulladdress.map((item, index) => (
                            <tr key={index}>
                              <td className="tdStyle">{index + 1}</td>
                              <td className="tdStyle">{item.Address1}</td>
                              <td className="tdStyle">{item.Address2}</td>
                              <td className="tdStyle">{item.City}</td>
                              <td className="tdStyle">{item.StateProvince}</td>
                              <td className="tdStyle">{item.Country}</td>
                              <td className="tdStyle">{item.Zip}</td>
                              <td className="tdStyle"> {item?.CreatedFrom}</td>
                              <td className="tdStyle">
                                {item.ID === yesID ? "Yes" : "No"}
                              </td>
                              <td className="tdStyle">
                                {item.IsDefault == 0 ? "Shipping" : "Billing"}
                              </td>
                              <td className="tdStyle">
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled={item.IsDefault == 0 ? false : true}
                                  onClick={() => {
                                    setAddressEdit(item);
                                    setOpen(true);
                                  }}
                                >
                                  {" "}
                                  Edit{" "}
                                </button>
                              </td>
                              <td className="tdStyle">
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled={item.IsDefault == 0 ? false : true}
                                  onClick={() => handleDeleteAddress(item)}
                                >
                                  {" "}
                                  Delete{" "}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Tab>
                  <Tab eventKey="fees" title="Delivery Fees">
                    <div className="row" style={{ "text-align": "left" }}>
                      <div className="col-12">
                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            {" "}
                            Delivery Fees{" "}
                          </label>
                          <div className="col-md-7">
                            <div class="input-group">
                              <span class="input-group-text">$</span>
                              <Field
                                type="number"
                                className="form-control"
                                onChange={(e) => {
                                  handleChange(e);
                                  // if (paramObject.id === undefined) {
                                  if (saleId == 0) {
                                    const x = {
                                      ...localValues,
                                      deliveryFees: e?.target?.value,
                                    };
                                    setLocalValues(x);
                                    localStorage.setItem(
                                      "DeliveryDraft",
                                      JSON.stringify(x)
                                    );
                                  }
                                }}
                                id="DeliveryFees"
                                name="DeliveryFees"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            Shipping Zone
                          </label>
                          <div className="col-md-7">
                            <Field
                              as="select"
                              className="form-control"
                              name="ShippingZone"
                              id="ShippingZone"
                              // value={StateSelected}
                              onChange={(e) => {
                                handleChange(e);
                                // if (paramObject.id === undefined) {
                                if (saleId == 0) {
                                  const x = {
                                    ...localValues,
                                    deliveryFees: e?.target?.value,
                                  };
                                  setLocalValues(x);
                                  localStorage.setItem(
                                    "ShippingZone",
                                    JSON.stringify(x)
                                  );
                                }
                              }}
                            >
                              <option value="0"> None </option>
                            </Field>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            Tax group
                          </label>
                          <div className="col-md-7">
                            <Field
                              as="select"
                              className="form-control"
                              onChange={(e) => handleTaxDropdown(e)}
                              name="Taxgroup"
                              // data-bs-dismiss="modal"
                              value={taxDropdownValue}
                              id="Taxgroup"
                            >
                              <option value=""> None </option>
                              {taxDropdown?.map((item) => {
                                return (
                                  <option value={item.GROUP_ID}>
                                    {item.Name}
                                  </option>
                                );
                              })}
                              {/* <option value="Taxes"> Taxes </option> */}
                            </Field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
                {activeTab !== "address" && (
                  <div
                    style={{ marginBottom: "70px" }}
                    className="col-lg-12 justify-content-right"
                  >
                    <button
                      type="submit"
                      className="btn btn-primary btn-md me-1"
                      data-bs-dismiss="modal"
                    >
                      Save Delivery
                    </button>
                    <Link
                      to="#"
                      onClick={handleCancelClick}
                      className="btn btn-dark btn-md me-1"
                      data-bs-dismiss="modal"
                    >
                      Cancel Delivery
                    </Link>
                  </div>
                )}
              </Form>
            )}
          </Formik>
          {/* Your modal content here */}
        </Modal.Body>
      </Modal>

      <AddressModal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        AddressEdit={AddressEdit}
        ID={customerid}
      />
    </>
  );
};

export default Deliveriescard;
